export const sideNavWidth = 100
